import type { WeekdayCode } from '@/types';

export interface WeekdaySlotDefinition {
  code: WeekdayCode;
  label: string;
  /**
   * Índice del día dentro de Date.getDay(). Domingo = 0.
   */
  weekdayIndex: number;
  slotsColumn: `${WeekdayCode}_slots`;
  oldSlotsColumn: `${WeekdayCode}_old_slots`;
}

export const WEEKDAY_SLOT_DEFINITIONS: WeekdaySlotDefinition[] = [
  { code: 'm', label: 'Lunes', weekdayIndex: 1, slotsColumn: 'm_slots', oldSlotsColumn: 'm_old_slots' },
  { code: 't', label: 'Martes', weekdayIndex: 2, slotsColumn: 't_slots', oldSlotsColumn: 't_old_slots' },
  { code: 'w', label: 'Miércoles', weekdayIndex: 3, slotsColumn: 'w_slots', oldSlotsColumn: 'w_old_slots' },
  { code: 'th', label: 'Jueves', weekdayIndex: 4, slotsColumn: 'th_slots', oldSlotsColumn: 'th_old_slots' },
  { code: 'f', label: 'Viernes', weekdayIndex: 5, slotsColumn: 'f_slots', oldSlotsColumn: 'f_old_slots' },
  { code: 's', label: 'Sábado', weekdayIndex: 6, slotsColumn: 's_slots', oldSlotsColumn: 's_old_slots' },
  { code: 'su', label: 'Domingo', weekdayIndex: 0, slotsColumn: 'su_slots', oldSlotsColumn: 'su_old_slots' },
];

export const WEEKDAY_CODE_BY_INDEX: Record<number, WeekdayCode> = WEEKDAY_SLOT_DEFINITIONS.reduce(
  (acc, def) => {
    acc[def.weekdayIndex] = def.code;
    return acc;
  },
  {} as Record<number, WeekdayCode>,
);
